import Layout from '@/views/layout'

export default [
  {
    path: '/dataCenter',
    name: 'dataCenter',
    redirect: '/dataCenter/dataCenter',
    component: Layout,
    meta: {
      title: '数据中心',
      icon: 'dataCenter.png',
      index: 13
    },
    children: [
      {
        path: 'dataCenter',
        name: 'dataCenter',
        meta: {
          title: '数据中心',
          id: '1621476594'
        },
        component: () => import('@/views/dataCenter/dataCenter')
      }
    ]
  }
]